import React from 'react';
import './filter-bar.css';

const FilterBar = ({ filters, onOpenModal, onClearFilters }) => {
  const activeFilters = [];

  // Build active filters array
  if (filters.reference) {
    activeFilters.push({ label: 'Reference', value: filters.reference, key: 'reference' });
  }
  if (filters.maskedPan) {
    activeFilters.push({ label: 'Masked PAN', value: filters.maskedPan, key: 'maskedPan' });
  }
  if (filters.merchantId) {
    activeFilters.push({ label: 'Merchant ID', value: filters.merchantId, key: 'merchantId' });
  }
  if (filters.merchantName) {
    activeFilters.push({ label: 'Merchant Name', value: filters.merchantName, key: 'merchantName' });
  }
  if (filters.terminalId) {
    activeFilters.push({ label: 'Terminal ID', value: filters.terminalId, key: 'terminalId' });
  }
  if (filters.settled !== undefined && filters.settled !== '') {
    const settledLabel = filters.settled === 'true' || filters.settled === true ? 'Settled' : 'Not Settled';
    activeFilters.push({ label: 'Settled', value: settledLabel, key: 'settled' });
  }
  if (filters.status !== undefined && filters.status !== '') {
    const statusLabel = filters.status === '1' ? 'Success' : filters.status === '0' ? 'Pending' : filters.status;
    activeFilters.push({ label: 'Status', value: statusLabel, key: 'status' });
  }
  if (filters.startDate) {
    activeFilters.push({ label: 'Start Date', value: filters.startDate, key: 'startDate' });
  }
  if (filters.endDate) {
    activeFilters.push({ label: 'End Date', value: filters.endDate, key: 'endDate' });
  }
  if (filters.provider) {
    activeFilters.push({ label: 'Provider', value: filters.provider, key: 'provider' });
  }
  if (filters.transactionType) {
    activeFilters.push({ label: 'Transaction Type', value: filters.transactionType, key: 'transactionType' });
  }
  if (filters.RetrievalReferenceNumber) {
    activeFilters.push({ label: 'Retrieval Reference Number', value: filters.RetrievalReferenceNumber, key: 'RetrievalReferenceNumber' });
  }
  if (filters.minAmount || filters.maxAmount) {
    if (filters.minAmount && filters.maxAmount) {
      activeFilters.push({ label: 'Amount Range', value: `${filters.minAmount} - ${filters.maxAmount}`, key: 'amountRange' });
    } else if (filters.minAmount) {
      activeFilters.push({ label: 'Min Amount', value: filters.minAmount, key: 'minAmount' });
    } else if (filters.maxAmount) {
      activeFilters.push({ label: 'Max Amount', value: filters.maxAmount, key: 'maxAmount' });
    }
  }

  const truncateValue = (value, maxLength = 30) => {
    if (!value) return value;
    const stringValue = String(value);
    return stringValue.length > maxLength ? `${stringValue.substring(0, maxLength)}...` : stringValue;
  };

  const hasActiveFilters = activeFilters.length > 0;

  return (
    <div className='filter-bar'>
      <div className='filter-bar-content'>
        <button className='filter-bar-button' onClick={onOpenModal}>
          <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M2 4h12M4 8h8M6 12h4' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
          </svg>
          Filter Table
        </button>

        {hasActiveFilters && (
          <div className='filter-bar-tags'>
            {activeFilters.map((filter) => (
              <span key={filter.key} className='filter-tag'>
                <span className='filter-tag-label'>{filter.label}:</span>
                <span className='filter-tag-value' title={filter.value}>
                  {truncateValue(filter.value)}
                </span>
                <button
                  className='filter-tag-remove'
                  onClick={() => {
                    const newFilters = { ...filters };
                    if (filter.key === 'amountRange') {
                      delete newFilters.minAmount;
                      delete newFilters.maxAmount;
                    } else {
                      delete newFilters[filter.key];
                    }
                    onClearFilters(newFilters);
                  }}>
                  ×
                </button>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterBar;
